import _asyncToGenerator from "D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchBox from '@/components/Search/SearchBox.vue';
import NoData from '@/components/NoData/NoData';
import DialogQusetion from './dialogQusetion.vue';
export default {
  data: function data() {
    var _JSON$parse, _JSON$parse$COMBINEDS;
    return {
      activeName: '综合搜索',
      systemList: ((_JSON$parse = JSON.parse(sessionStorage.getItem('dist_info'))) === null || _JSON$parse === void 0 ? void 0 : (_JSON$parse$COMBINEDS = _JSON$parse.COMBINEDSEARCH) === null || _JSON$parse$COMBINEDS === void 0 ? void 0 : _JSON$parse$COMBINEDS.LC_WEB) || [],
      systemId: '',
      list: [],
      searchVal: '',
      resultList: [],
      cateGoryName: '',
      searchResult: '',
      categoryObj: {},
      loading: false,
      isPrecise: true,
      showRelation: false,
      relationTitel: '',
      DialogQuestion: {},
      relatedDialogQuestion: [],
      heightSearchObj: {
        LC_IE: {
          url: 'http://lc-ie-dev3.hexasino.com',
          path: '/detail'
        },
        LC_RI: {
          url: 'http://lc-rms.hexasino.com',
          path: '/systemDetails'
        },
        LC_FAQ: {
          url: 'http://lc-faq-dev3.hexasino.com',
          path: '/legalqa/qacouple'
        },
        LC_REGULATORY_TRENDS: {
          url: 'http://lc-rt-pc-dev3.hexasino.com',
          path: ''
        },
        LC_PUNISH: {
          url: 'http://lc-punish-pc-dev3.hexasino.com',
          path: ''
        },
        LCC: {
          url: 'http://lcc-pc-dev3.hexasino.com',
          path: '/agreement/contractView'
        }
      },
      systemInner: JSON.parse(sessionStorage.getItem('systemInner')),
      riCount: ''
    };
  },
  methods: {
    /**
     * @description: 获取RMS分类的字典数据
     * @return {*}
     */
    getRegulationCategory: function getRegulationCategory() {
      var _this = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var data;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                data = new FormData();
                data.append('systemId', 'LC_RI');
                _context.next = 4;
                return _this.$API.postRequest({
                  url: '/platform/superSearch/getRegulationCategory',
                  data: data
                }).then(function (res) {
                  if (res.code === '0000000000') {
                    JSON.parse(res.result.data).children.forEach(function (ele) {
                      _this.categoryObj[ele.pathId] = ele.name;
                    });
                    _this.searchTitle(_this.searchVal, _this.systemId);
                  }
                });
              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getMore: function getMore() {
      this.$refs.searchBox.searchClick('getMore', this.activeName);
    },
    toNewPageFaq: function toNewPageFaq(question, qid, cid) {
      var _this2 = this;
      question = question.replace(/(\n)/g, '');
      question = question.replace(/(\t)/g, '');
      question = question.replace(/(\r)/g, '');
      question = question.replace(/<\/?[^>]*>/g, '');
      question = question.replace(/\s*/g, '');
      var path = "/legalqa/qacouple?keyword=".concat(question, "&qid=").concat(qid, "&cid=").concat(cid);
      var url = '';
      this.systemInner.forEach(function (ele) {
        if (ele.systemId === _this2.systemId) {
          url = ele.baseUrl;
        }
      });
      window.open(decodeURIComponent("".concat(window.location.origin, "/?newPage=").concat(url, "&menuPath=").concat(path, "&isChecked=true&isHash=1")));
    },
    toNewPage: function toNewPage(id, pdfId) {
      var systemId = this.systemId;
      var path = '';
      var isHash = 1;
      if (systemId === 'LC_IE') {
        path = "/instDetail?instId=".concat(id);
      } else if (systemId === 'LC_REGULATORY_TRENDS') {
        path = "/detailPage?detailId=".concat(id);
      } else if (systemId === 'LC_PUNISH') {
        path = "/detailPage?detailId=".concat(id);
      } else if (systemId === 'LC_RI') {
        path = "/systemDetails?id=".concat(id);
        isHash = 0;
      } else if (systemId === 'LCC') {
        path = "/agreement/contractView?pdfId=".concat(pdfId, "&conId=").concat(id);
        isHash = 0;
      }
      var url = '';
      this.systemInner.forEach(function (ele) {
        if (ele && ele.systemId === systemId) {
          url = ele.baseUrl;
        }
      });
      window.open(decodeURIComponent("".concat(window.location.origin, "/?newPage=").concat(url, "&menuPath=").concat(path, "&isHash=").concat(isHash)));
    },
    setSysId: function setSysId(systemId, searchValue) {
      if (systemId === '') {
        // eslint-disable-next-line guard-for-in
        for (var key in this.systemList) {
          systemId = key;
          break;
        }
      }
      this.systemId = systemId;
      this.activeName = systemId;
      this.searchTitle(searchValue, systemId);
    },
    searchTitle: function searchTitle(keyWord, systemId) {
      var _this3 = this;
      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(systemId === '')) {
                  _context2.next = 4;
                  break;
                }
                _context2.next = 3;
                return _this3.$API.postRequest({
                  url: '/platform/superSearch/selectSystemBySearchKey',
                  data: {
                    keyWord: keyWord
                  }
                }).then(function (res) {
                  if (res.result) {
                    systemId = res.result;
                  } else {
                    // eslint-disable-next-line guard-for-in
                    for (var key in _this3.systemList) {
                      systemId = key;
                      break;
                    }
                  }
                });
              case 3:
                // eslint-disable-next-line guard-for-in
                // for (const key in this.systemList) {
                //   systemId = key;
                //   break;
                // }
                if (keyWord !== '') {
                  _this3.$API.postRequest({
                    url: '/platform/superSearch/saveHistory',
                    data: {
                      keyWord: keyWord
                    }
                  });
                }
              case 4:
                _this3.activeName = systemId;
                _this3.loading = true;
                _this3.resultList = [];
                if (systemId === 'LCC') {
                  _this3.$API.postRequest({
                    url: '/contract/search/search',
                    data: {
                      pageNum: 1,
                      pageSize: 10,
                      totalCount: 10,
                      requestVO: {
                        isPrecise: false,
                        keyWord: keyWord,
                        orderBy: 'RELATED',
                        orderDescending: 'DESC',
                        searchFields: {
                          businessType: [],
                          contractTitle: null,
                          effectiveDateEnd: null,
                          effectiveDateStart: null,
                          expireDateEnd: null,
                          expireDateStart: null,
                          instIssueNum: null,
                          instTitle: null,
                          publishOrg: [],
                          scope: [],
                          status: []
                        }
                      }
                    }
                  }).then(function (res) {
                    _this3.loading = false;
                    if (['SUC000000', '0000000', '0000000000'].includes(res.code)) {
                      _this3.resultList = res.result.data || [];
                    }
                  });
                } else {
                  _this3.$API.postRequest({
                    url: '/platform/superSearch/searchCategory',
                    data: {
                      keyWord: keyWord,
                      pageNum: 1,
                      pageSize: systemId === 'FAQ' ? 1 : 10,
                      systemId: systemId,
                      precise: _this3.$refs.searchBox ? _this3.$refs.searchBox.isPrecise : _this3.$route.query.isPrecise !== '0'
                    }
                  }).then(function (res) {
                    _this3.loading = false;
                    if (res.code === '0000000000') {
                      _this3.systemId = systemId;
                      _this3.list.forEach(function (ele) {
                        if (systemId === ele.systemId) {
                          if (systemId === 'LC_RI') {
                            var _JSON$parse2, _JSON$parse2$, _JSON$parse3, _JSON$parse3$;
                            var categoryList = [{
                              tabCategoryName: '中央法规',
                              tabCategoryId: 'CENTRAL_REG',
                              totalCount: (_JSON$parse2 = JSON.parse(res.result.data)) === null || _JSON$parse2 === void 0 ? void 0 : (_JSON$parse2$ = _JSON$parse2[0]) === null || _JSON$parse2$ === void 0 ? void 0 : _JSON$parse2$.termCount.CENTRAL_REG
                            }, {
                              tabCategoryName: '地方法规',
                              tabCategoryId: 'LOCAL_REG',
                              totalCount: (_JSON$parse3 = JSON.parse(res.result.data)) === null || _JSON$parse3 === void 0 ? void 0 : (_JSON$parse3$ = _JSON$parse3[0]) === null || _JSON$parse3$ === void 0 ? void 0 : _JSON$parse3$.termCount.LOCAL_REG
                            }];
                            _this3.$set(ele, 'Category', categoryList);
                          } else {
                            _this3.$set(ele, 'Category', JSON.parse(res.result.data));
                          }
                        }
                      });
                      _this3.cateGoryName = 0;
                      _this3.searchResult = JSON.parse(res.result.data);
                      if (systemId === 'LC_IE') {
                        var _JSON$parse4, _JSON$parse4$;
                        _this3.resultList = ((_JSON$parse4 = JSON.parse(res.result.data)) === null || _JSON$parse4 === void 0 ? void 0 : (_JSON$parse4$ = _JSON$parse4[0]) === null || _JSON$parse4$ === void 0 ? void 0 : _JSON$parse4$.data) || [];
                      }
                      if (systemId === 'LC_RI') {
                        var _JSON$parse5, _JSON$parse5$;
                        _this3.resultList = ((_JSON$parse5 = JSON.parse(res.result.data)) === null || _JSON$parse5 === void 0 ? void 0 : (_JSON$parse5$ = _JSON$parse5[0]) === null || _JSON$parse5$ === void 0 ? void 0 : _JSON$parse5$.data) || [];
                      }
                      if (systemId === 'LC_FAQ') {
                        _this3.resultList = JSON.parse(res.result.data).questionAnswers.data;
                        // eslint-disable-next-line array-callback-return
                        _this3.resultList.filter(function (item) {
                          _this3.$set(item, 'isHideDetail', true);
                          _this3.$set(item, 'relatedQuestions', []);
                        });
                      }
                      if (systemId === 'LC_REGULATORY_TRENDS') {
                        var _JSON$parse6, _JSON$parse6$;
                        _this3.resultList = ((_JSON$parse6 = JSON.parse(res.result.data)) === null || _JSON$parse6 === void 0 ? void 0 : (_JSON$parse6$ = _JSON$parse6[0]) === null || _JSON$parse6$ === void 0 ? void 0 : _JSON$parse6$.searchRespAll.searchRespVOList) || [];
                      }
                      if (systemId === 'LC_PUNISH') {
                        var _JSON$parse7, _JSON$parse7$;
                        _this3.resultList = ((_JSON$parse7 = JSON.parse(res.result.data)) === null || _JSON$parse7 === void 0 ? void 0 : (_JSON$parse7$ = _JSON$parse7[0]) === null || _JSON$parse7$ === void 0 ? void 0 : _JSON$parse7$.searchRespAll.administrativePunish) || [];
                      }
                    }
                  });
                }
              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    // eslint-disable-next-line no-unused-vars
    tabClick: function tabClick() {
      var name = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
      var systemId = arguments.length > 1 ? arguments[1] : undefined;
      var index = arguments.length > 2 ? arguments[2] : undefined;
      var tabCategoryId = arguments.length > 3 ? arguments[3] : undefined;
      this.cateGoryName = index;
      if (systemId === 'LC_IE') {
        this.resultList = this.searchResult[index].data || [];
      } else {
        this.search(systemId, this.$refs.searchBox.searchValue, tabCategoryId);
      }
    },
    search: function search(systemId, keyWord) {
      var _this4 = this;
      var categoryId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      this.$API.postRequest({
        url: '/platform/superSearch/search',
        data: {
          systemId: systemId,
          keyWord: keyWord,
          pageSize: 10,
          pageNum: 1,
          categoryId: categoryId,
          precise: this.$refs.searchBox.isPrecise
        }
      }).then(function (res) {
        if (res.code === '0000000000') {
          if (systemId === 'LC_RI') {
            _this4.resultList = JSON.parse(res.result.data).data;
          } else if (systemId === 'LC_FAQ') {
            _this4.resultList = JSON.parse(res.result.data).data;
            // eslint-disable-next-line array-callback-return
            _this4.resultList.filter(function (item) {
              _this4.$set(item, 'isHideDetail', true);
              _this4.$set(item, 'relatedQuestions', []);
            });
          } else if (systemId === 'LC_REGULATORY_TRENDS') {
            var _JSON$parse8, _JSON$parse8$;
            _this4.resultList = ((_JSON$parse8 = JSON.parse(res.result.data)) === null || _JSON$parse8 === void 0 ? void 0 : (_JSON$parse8$ = _JSON$parse8[0]) === null || _JSON$parse8$ === void 0 ? void 0 : _JSON$parse8$.searchRespAll.searchRespVOList) || [];
          } else if (systemId === 'LC_PUNISH') {
            var _JSON$parse9, _JSON$parse9$;
            _this4.resultList = ((_JSON$parse9 = JSON.parse(res.result.data)) === null || _JSON$parse9 === void 0 ? void 0 : (_JSON$parse9$ = _JSON$parse9[0]) === null || _JSON$parse9$ === void 0 ? void 0 : _JSON$parse9$.searchRespAll.administrativePunish) || [];
          }
        }
      });
    },
    handleClick: function handleClick(tab) {
      this.cateGoryName = 0;
      this.systemId = tab.name;
      this.searchTitle(this.$refs.searchBox.searchValue, this.systemId);
    },
    readmore: function readmore(item) {
      item.isHideDetail = false;
      this.$API.getRequest({
        url: "/qa/search/getRelatedQuestions?cid=".concat(item.cid, "&qid=").concat(item.qid, "&size=4")
      }).then(function (res) {
        item.relatedQuestions = res.result;
      });
    },
    hideDetail: function hideDetail(item) {
      item.isHideDetail = true;
    },
    showRelatedQuestionModal: function showRelatedQuestionModal(question) {
      var _this5 = this;
      this.relationTitel = question.question;
      this.DialogQuestion = question;
      this.showRelation = true;
      this.$API.getRequest({
        url: "/qa/search/getRelatedQuestions?cid=".concat(question.cid, "&qid=").concat(question.qid, "&size=4")
      }).then(function (res) {
        _this5.relatedDialogQuestion = res.result;
      });
    }
  },
  mounted: function mounted() {
    var _this6 = this;
    this.searchVal = this.$route.query.keyWord;
    this.systemId = this.$route.query.systemId;
    Object.keys(this.systemList).forEach(function (key, index) {
      if (index === 0) {
        _this6.activeName = key;
      }
      if (_this6.systemId === key) {
        _this6.activeName = key;
      }
      _this6.list.push({
        systemId: key,
        Category: []
      });
    });
  },
  computed: {
    replaceStr: function replaceStr() {
      return function (str) {
        return str.replace(/<span.*?>(.*?)<\/span>/g, '$1');
      };
    },
    typeStr: function typeStr() {
      return function (arr) {
        return arr.toString().replace(',', '/');
      };
    }
  },
  created: function created() {
    this.searchTitle(this.$route.query.keyWord, ''); // 默认进入页面时，获取综合搜索结果
    // this.searchTitle(this.$route.query.keyWord,Object.keys(this.systemList)[0] );//获取RMS
  },

  components: {
    SearchBox: SearchBox,
    NoData: NoData,
    DialogQusetion: DialogQusetion
  }
};